<template src="./index.html">
</template>
<script>
	import {getdata} from './data.js'
	export default {
		name: '',
		components: {},
		props:{
			toseeUpdate: {
				type: Boolean,
				default: false
			},
			tableDataI:{
				type: Array,
				default: [],
			},
			tableDataII:{
				type: Array,
				default: [],
			},
			tableDataIII:{
				type: Array,
				default: [],
			},
			tableDataIV:{
				type: Array,
				default: [],
			},
			headobj: {
				type: Object,
				default: {},
			},
			choosecellCode:{
				type:String,
				default:""
			},
			type: {
				type: String,
				default: ""
			},
      otherDialog_8_tableData: {
        type: Array,
        default: [],
      },
      otherDialog_23_tableData: {
        type: Array,
        default: [],
      }
		},
    watch: {
      otherDialog_8_tableData: function (indexVal, oldVal) {
      },
      otherDialog_23_tableData: function (indexVal, oldVal) {
      },
    },
		data: function() {
			return {
				headDataI: getdata().headDataI,
				headDataII: getdata().headDataII,
				headDataIII: getdata().headDataIII,
				headDataIV: getdata().headDataIV,
        otherDialogFlag_8: false,
        otherDialog_8_headData: getdata().otherDialog_8_headData,
        otherDialogFlag_23: false,
        otherDialog_23_headData: getdata().otherDialog_23_headData,
			};
		},
		created() {},
		methods: {
			inputblur(e){
			  this.$emit("inputblur",e)
        if (e.cellCode === "zzs_2_8b_1" && e.cellVal !== "0.00") {
          this.otherDialogFlag_8 = true;
        }
        if (e.cellCode === "zzs_2_23b_1" && e.cellVal !== "0.00") {
          this.otherDialogFlag_23 = true;
        }
			},
			forhover(table,colum,index){
				this.$emit("forhover",table,colum,index)
			},
			zcsclick(e){
				this.$emit("zcsclick",e)
			},
      otherDialog_8_confirm() {
        this.otherDialogFlag_8 = false;
        this.$emit("writeBackOtherDialog_8");
      },
      otherDialog_23_confirm() {
        this.otherDialogFlag_23 = false;
        this.$emit("writeBackOtherDialog_23");
      },
      otherDialogInputblur(type) {
        let sum = 0;
        for (let i = 1; i < this.otherDialog_8_tableData.length; i++) {
          let data = this.otherDialog_8_tableData[i];
          if (type === 1 && data.zzs_mxtk_2_8b_x_3.cellVal !== "--") {
            // 份数小计
            sum = this.$calc.add(sum, parseFloat(data.zzs_mxtk_2_8b_x_3.cellVal || 0))
          } else if (type === 2 && data.zzs_mxtk_2_8b_x_4.cellVal !== "--") {
            // 金额小计
            sum = this.$calc.add(sum, parseFloat(data.zzs_mxtk_2_8b_x_4.cellVal || 0))
          } else if (type === 3) {
            // 税额小计
            sum = this.$calc.add(sum, parseFloat(data.zzs_mxtk_2_8b_x_5.cellVal || 0))
          }
        }
        if (type === 1) {
          // 份数小计
          this.otherDialog_8_tableData[0].zzs_mxtk_2_8b_x_3.cellVal = sum;
        } else if (type === 2) {
          // 金额小计
          this.otherDialog_8_tableData[0].zzs_mxtk_2_8b_x_4.cellVal = sum;
        } else if (type === 3) {
          // 税额小计
          this.otherDialog_8_tableData[0].zzs_mxtk_2_8b_x_5.cellVal = sum;
        }
      },
      otherDialogInputblur_23() {
        let sum = 0;
        for (let i = 1; i < this.otherDialog_23_tableData.length; i++) {
          let data = this.otherDialog_23_tableData[i];
          sum = this.$calc.add(sum, parseFloat(data.zzs_mxtk_2_23b_x_3.cellVal || 0))
        }
        this.otherDialog_23_tableData[0].zzs_mxtk_2_23b_x_3.cellVal = sum;
      }
		}
	};
</script>


<style scoped lang="less">
	@import url('./index.less');
	@import url('../../SalesTaxReport/index.less');
</style>
